/**
 * @file automatically generated from MApp.Endpoints.StyleEditorController
 */ 

import { MetadataClient } from '../metadataClient';
import { IVectorLayer } from '../models/clients';
import { IStyleEditorLayer, ISaveStyle, ISymbol, IStylePreview } from '../models';

export class StyleEditorClient extends MetadataClient {

    public static getVectorLayer(id: string) {
        return MetadataClient.ajax<IVectorLayer>(
            new Request(MetadataClient.endpointsUrl + `api/v4/styleeditor/layers/${encodeURIComponent(id)}`)
        );
    }

    public static getVectors() {
        return MetadataClient.ajax<IStyleEditorLayer[]>(
            new Request(MetadataClient.endpointsUrl + `api/v4/styleeditor/layers`)
        );
    }

    public static styleSet(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/stylesets/${encodeURIComponent(id)}`)
        );
    }

    public static saveStyleSet() {
        return MetadataClient.ajax<string>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/stylesets`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST'
			})
        );
    }

    public static updateStyleSet(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/stylesets/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT'
			})
        );
    }

    public static updateStyleSetV2(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v2/styleeditor/stylesets/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT'
			})
        );
    }

    public static style(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/styles/${encodeURIComponent(id)}`)
        );
    }

    public static saveStyle(style: ISaveStyle) {
        return MetadataClient.ajax<string>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/styles`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(style)
			})
        );
    }

    public static updateStyle(id: string, style: ISaveStyle) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/styles/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(style)
			})
        );
    }

    public static deleteSymbol(styleSetId: string, fileName: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/symbols/${encodeURIComponent(styleSetId)}/${encodeURIComponent(fileName)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getSymbols(styleSetId: string) {
        return MetadataClient.ajax<ISymbol[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/symbols/${encodeURIComponent(styleSetId)}`)
        );
    }

    public static getFonts() {
        return MetadataClient.ajax<string[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/fonts`)
        );
    }

    public static preview(preview: IStylePreview) {
        return MetadataClient.ajax<string>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/previews`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(preview)
			})
        );
    }

    public static previewAll(preview: IStylePreview) {
        return MetadataClient.ajax<{ [key: string]: string; }>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/previews/all`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(preview)
			})
        );
    }

    public static getFields(name: string) {
        return MetadataClient.ajax<{ [key: string]: string[]; }>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/styles/${encodeURIComponent(name)}/fields`)
        );
    }

    public static getFieldValues(styleName: string, fieldName: string, filter: string, isString: boolean) {
        return MetadataClient.ajax<string[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/typeahead/${encodeURIComponent(styleName)}/${encodeURIComponent(fieldName)}/${encodeURIComponent(filter)}/${isString}`)
        );
    }

    public static getRangeFromFieldValues(styleName: string, fieldName: string) {
        return MetadataClient.ajax<string[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/getrange/${encodeURIComponent(styleName)}/${encodeURIComponent(fieldName)}//`)
        );
    }

    public static getMostFrequentFieldValues(styleName: string, fieldName: string, filter: string, isString: boolean) {
        return MetadataClient.ajax<string[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/typeahead/mostfrequently/${encodeURIComponent(styleName)}/${encodeURIComponent(fieldName)}/${encodeURIComponent(filter)}/${isString}`)
        );
    }
    
    public static saveSymbol(formData: FormData, styleSetId: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/styleeditor/symbols/${encodeURIComponent(styleSetId)}/upload`, {
				headers: new Headers({ }),
				method: 'POST',
				body: formData,
				cache: 'no-cache'
			})
        );
    }
}
